import React, {useState } from "react";
import './App.css';
import Navbar from "./Component/Navbar";
import Footer from "./Component/Footer";
import Home from "./Pages/Home/Home";
import { Route, Routes, useLocation} from "react-router-dom";
import  * as Router from './Routes';
import AboutUs from "./Pages/AboutUs/AboutUs";
import Game from "./Pages/Game/Game";
import Progressive from './Pages/Services/progressiveapp/Progressive';
import Blockchain from "./Pages/Blockchian/Blockchain";
import OurWork from "./Pages/OurWork/OurWork";
import NewOurWork from './Pages/OurWork/NewOurWork'
import OurPartners from './Pages/OurPartners/OurPartners'
import WebDevelopment from "./Pages/WebDevelopment/WebDevelopment";
import GameDev from "./Pages/GameDevelopment/GameDev";
import AppDevelopment from "./Pages/AppDevelopment/AppDevelopment";
import Metaverse from "./Pages/Metaverse/Metaverse";
import ContactUs from "./Pages/ContactUs/ContactUs";
import TermsAndCondition from "./Pages/TermsAndContion/TermsAndCondition";
import PrivacyAndPolicy from "./Pages/PrivacyAndPolicy/PrivacyAndPolicy";
import Ethereum from "./Pages/Ethereum/Ethereum";
import CryptoCurrency from "./Pages/CryptoCurrency/CryptoCurrency";
import NftMarketPlace from "./Pages/NftMarketPlace/NftMarketPlace";
import Nft from "./Pages/Nfts/Nft";
import ExchangeCrypto from "./Pages/ExchangeCrypto/ExchangeCrypto";
import ScrollToTop from "./Component/ScrollToTop ";
import { WhatsappIcon } from "./Component/WhatsappIcon";
import Thankyou from "./Pages/AboutUs/Thankyou";
import Application from "./Pages/Careers/Application";
import Careers from "./Pages/Careers/Careers";
import JobList from "./Pages/Careers/JobList";
import { JobDescription } from "./Pages/Careers/JobDescription";
import { ToastContainer } from "react-toastify";
import { AllJobs } from "./Pages/Careers/AllJobs";
import { MainServicePage } from "./Component/NewServices/MainServicePage";
import { CaseStudy } from "./Component/CaseStudty/CaseStudy";
import Team from "./Component/Team/Team";
import MainBlog from "./Pages/BlogMainPage/BlogList/MainBlog";
import BlogDetail from "./Pages/BlogMainPage/BlogDetails/BlogDetail";
import RefundPolicy from "./Pages/RefundPolicy/RefundPolicy";
import WebsiteDev from "./Pages/Services/WebsiteDevelopment/WebsiteDevelopment";
import WebsiteDevelopment from "./Pages/Services/WebsiteDevelopment/WebsiteDevelopment";
import ARVR from "./Pages/Services/ARVRDevelopment/ARVR";
import { useEffect } from "react";
import ARVRDevelopmentServices from "./Pages/Services/ARVRDevelopment/ARVRDevelopmentServices ";
import MobileAppDevelopment from "./Pages/MobileAppDevelopment/MobileAppDevelopment";
import WebDevelopmentSerivce from "./Pages/Services/WebDevelopmentService/WebDevelopmentSerivce";
import UiService from "./Pages/Services/UiService/UiService";
// import { BrowserRouter as Route } from "react-router-dom";
import Crm from "./Pages/Services/CustomCrm/Crm";


function App() {
   const [showDropDown, setShowDropDown] = useState(false);
  const location = useLocation(); 
  const hideFooterOnPaths = [Router.ARVRDEV]; 
  const shouldShowHeaderFooter = !hideFooterOnPaths.includes(location.pathname);

useEffect(() => {
  if (location.pathname === "/ar-vr-development") {
    document.body.classList.add("route-ar-vr-development");
  } else {
    document.body.classList.remove("route-ar-vr-development");
  }
}, [location.pathname]);


  return (
      <div onClick={() => setShowDropDown(false)}>  
         {shouldShowHeaderFooter && <Navbar showDropDown={showDropDown} setShowDropDown={setShowDropDown}/>} 
          <ScrollToTop />
          <Routes>
            <>
           <Route path={Router.HOME} element={<Home/>}/>
           <Route path={Router.ABOUTUS} element={<AboutUs/>}/>
           <Route path={Router.THANKYOU} element={<Thankyou/>}/>
           <Route path={Router.CONTACTUS} element={<ContactUs/>}/>
            <Route path={Router.GAMEDEV} element={<GameDev/>}/>
           <Route path={Router.GAME} element={<Game/>}/>
           <Route path={Router.PROGRESSIVE} element={<Progressive/>}/>
           <Route path={Router.BLOCKCHAIN} element={<Blockchain/>}/>
           <Route path={Router.WEBDEVELOPEMENT} element={<WebDevelopment/>}/>
           <Route path={Router.APPDEVELOPMENT} element={<AppDevelopment/>} />
           <Route path={Router.OURWORK} element={<NewOurWork/>}/>
           <Route path={Router.OURPARTNERS} element={<OurPartners/>}/>
           <Route path={Router.METAVERSEDEVELOPMENT} element={<Metaverse/>}/>
           <Route path={Router.TERMSANDCONDITIONS} element={<TermsAndCondition/>}/>
           <Route path={Router.PRIVACYANDPOLICY} element={<PrivacyAndPolicy/>}/>
           <Route path={Router.REFUNDPOLICY} element={<RefundPolicy/>}/>
           <Route path={Router.ETHEREUM} element={<Ethereum/>}/>
           <Route path={Router.CRYPTOCURRENCY} element={<CryptoCurrency/>}/>
           <Route path={Router.NFTMARKETPLACE} element={<NftMarketPlace/>} />
           <Route path={Router.NFT} element={<Nft/>}/>
           <Route path={Router.EXCHANGECRYPTO} element={<ExchangeCrypto/>}/>
           <Route path={Router.APPLICATION} element={<Application/>}/>
           <Route path={Router.CAREERS} element={<Careers/>}/>
           <Route path={Router.DEFAULT} element={<Home/>}/>
           <Route path={Router.SWIPER} element={<JobList/>}/>
           <Route path={Router.JOBDESCRIPTION} element={<JobDescription/>}/>
           <Route path={Router.ALLJOBS} element={<AllJobs/>}/>
           <Route path={Router.BLOGMAINPAGE} element={<MainBlog/>}/>
           <Route path={Router.BLOGDETAIL} element={<BlogDetail/>}/>
           {/* <Route path={Router.WEBDEV} element={<WebsiteDevelopment/>}/> */}
           <Route path={Router.MOBILEAPPDEVELOPMENT} element={<MobileAppDevelopment/>}/>
           <Route path={Router.WEBDEV} element={<WebDevelopmentSerivce/>}/>
            <Route path={Router.ARVRDEV} element={<ARVR/>}/>
            <Route path={Router.ARVRDevelopmentServices} element={<ARVRDevelopmentServices/>}/>
           {/* <Route path={Router.SERVICES} element={<MainServicePage/>}/> */}
           <Route path={Router.CASE_STUDY} element={<CaseStudy/>}/>
           {/* <Route path={Router.TEAM} element={<Team/>}/> */}
           <Route path={Router.UIUX} element={<UiService/>}/>
           <Route path={Router.CRMDEVELOPMENT} element={<Crm/>}/>
           </>
          </Routes>
          {shouldShowHeaderFooter && <Footer/>}
          <WhatsappIcon />
          <ToastContainer
        position="top-right"
        autoClose={3000} 
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> 
      </div>
  );
}

export default App;
